"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Boolean = _interopRequireDefault(require("./Boolean01"));
var _BooleanJN = _interopRequireDefault(require("./BooleanJN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallPreis model module.
 * @module model/EdelmetallPreis
 * @version 1.0.44
 */
var EdelmetallPreis = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallPreis</code>.
   * Detailinformationen zu einem Edelmetall
   * @alias module:model/EdelmetallPreis
   * @param kennziffer {String} eindeutige Identifikationsnummer des Edelmetalls
   * @param bezeichnung {String} Langtext des Edelmetalls
   * @param preis {Number} Preis des Edelmetalls
   * @param konditionenProzent {Number} Prozenzsatz der Standard-Konditionen
   * @param innenProvision {Number} Wie hoch ist die Innenprovision
   * @param mwstProzent {Number} Mehrwertsteuersatz für das Edelmetall
   * @param goldKz {module:model/Boolean01} 
   * @param silberKz {module:model/Boolean01} 
   * @param platinKz {module:model/Boolean01} 
   * @param palladiumKz {module:model/Boolean01} 
   * @param sonstigeKz {module:model/Boolean01} 
   * @param barrenKz {module:model/Boolean01} 
   * @param muenzenKz {module:model/Boolean01} 
   * @param zubehoerKz {module:model/Boolean01} 
   * @param kassettenKz {module:model/Boolean01} 
   * @param rchargeKz {module:model/BooleanJN} 
   * @param diffsteuerungKz {module:model/BooleanJN} 
   * @param preissteuerungKz {module:model/BooleanJN} 
   */
  function EdelmetallPreis(kennziffer, bezeichnung, preis, konditionenProzent, innenProvision, mwstProzent, goldKz, silberKz, platinKz, palladiumKz, sonstigeKz, barrenKz, muenzenKz, zubehoerKz, kassettenKz, rchargeKz, diffsteuerungKz, preissteuerungKz) {
    _classCallCheck(this, EdelmetallPreis);
    EdelmetallPreis.initialize(this, kennziffer, bezeichnung, preis, konditionenProzent, innenProvision, mwstProzent, goldKz, silberKz, platinKz, palladiumKz, sonstigeKz, barrenKz, muenzenKz, zubehoerKz, kassettenKz, rchargeKz, diffsteuerungKz, preissteuerungKz);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallPreis, null, [{
    key: "initialize",
    value: function initialize(obj, kennziffer, bezeichnung, preis, konditionenProzent, innenProvision, mwstProzent, goldKz, silberKz, platinKz, palladiumKz, sonstigeKz, barrenKz, muenzenKz, zubehoerKz, kassettenKz, rchargeKz, diffsteuerungKz, preissteuerungKz) {
      obj['kennziffer'] = kennziffer;
      obj['bezeichnung'] = bezeichnung;
      obj['preis'] = preis;
      obj['konditionen_prozent'] = konditionenProzent;
      obj['innen_provision'] = innenProvision;
      obj['mwst_prozent'] = mwstProzent;
      obj['gold_kz'] = goldKz;
      obj['silber_kz'] = silberKz;
      obj['platin_kz'] = platinKz;
      obj['palladium_kz'] = palladiumKz;
      obj['sonstige_kz'] = sonstigeKz;
      obj['barren_kz'] = barrenKz;
      obj['muenzen_kz'] = muenzenKz;
      obj['zubehoer_kz'] = zubehoerKz;
      obj['kassetten_kz'] = kassettenKz;
      obj['rchargeKz'] = rchargeKz;
      obj['diffsteuerungKz'] = diffsteuerungKz;
      obj['preissteuerungKz'] = preissteuerungKz;
    }

    /**
     * Constructs a <code>EdelmetallPreis</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallPreis} obj Optional instance to populate.
     * @return {module:model/EdelmetallPreis} The populated <code>EdelmetallPreis</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallPreis();
        if (data.hasOwnProperty('kennziffer')) {
          obj['kennziffer'] = _ApiClient.default.convertToType(data['kennziffer'], 'String');
        }
        if (data.hasOwnProperty('bezeichnung')) {
          obj['bezeichnung'] = _ApiClient.default.convertToType(data['bezeichnung'], 'String');
        }
        if (data.hasOwnProperty('preis')) {
          obj['preis'] = _ApiClient.default.convertToType(data['preis'], 'Number');
        }
        if (data.hasOwnProperty('konditionen_prozent')) {
          obj['konditionen_prozent'] = _ApiClient.default.convertToType(data['konditionen_prozent'], 'Number');
        }
        if (data.hasOwnProperty('innen_provision')) {
          obj['innen_provision'] = _ApiClient.default.convertToType(data['innen_provision'], 'Number');
        }
        if (data.hasOwnProperty('mwst_prozent')) {
          obj['mwst_prozent'] = _ApiClient.default.convertToType(data['mwst_prozent'], 'Number');
        }
        if (data.hasOwnProperty('gold_kz')) {
          obj['gold_kz'] = _Boolean.default.constructFromObject(data['gold_kz']);
        }
        if (data.hasOwnProperty('silber_kz')) {
          obj['silber_kz'] = _Boolean.default.constructFromObject(data['silber_kz']);
        }
        if (data.hasOwnProperty('platin_kz')) {
          obj['platin_kz'] = _Boolean.default.constructFromObject(data['platin_kz']);
        }
        if (data.hasOwnProperty('palladium_kz')) {
          obj['palladium_kz'] = _Boolean.default.constructFromObject(data['palladium_kz']);
        }
        if (data.hasOwnProperty('sonstige_kz')) {
          obj['sonstige_kz'] = _Boolean.default.constructFromObject(data['sonstige_kz']);
        }
        if (data.hasOwnProperty('barren_kz')) {
          obj['barren_kz'] = _Boolean.default.constructFromObject(data['barren_kz']);
        }
        if (data.hasOwnProperty('muenzen_kz')) {
          obj['muenzen_kz'] = _Boolean.default.constructFromObject(data['muenzen_kz']);
        }
        if (data.hasOwnProperty('zubehoer_kz')) {
          obj['zubehoer_kz'] = _Boolean.default.constructFromObject(data['zubehoer_kz']);
        }
        if (data.hasOwnProperty('kassetten_kz')) {
          obj['kassetten_kz'] = _Boolean.default.constructFromObject(data['kassetten_kz']);
        }
        if (data.hasOwnProperty('rchargeKz')) {
          obj['rchargeKz'] = _BooleanJN.default.constructFromObject(data['rchargeKz']);
        }
        if (data.hasOwnProperty('diffsteuerungKz')) {
          obj['diffsteuerungKz'] = _BooleanJN.default.constructFromObject(data['diffsteuerungKz']);
        }
        if (data.hasOwnProperty('preissteuerungKz')) {
          obj['preissteuerungKz'] = _BooleanJN.default.constructFromObject(data['preissteuerungKz']);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallPreis</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallPreis</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(EdelmetallPreis.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['kennziffer'] && !(typeof data['kennziffer'] === 'string' || data['kennziffer'] instanceof String)) {
        throw new Error("Expected the field `kennziffer` to be a primitive type in the JSON string but got " + data['kennziffer']);
      }
      // ensure the json data is a string
      if (data['bezeichnung'] && !(typeof data['bezeichnung'] === 'string' || data['bezeichnung'] instanceof String)) {
        throw new Error("Expected the field `bezeichnung` to be a primitive type in the JSON string but got " + data['bezeichnung']);
      }
      return true;
    }
  }]);
}();
EdelmetallPreis.RequiredProperties = ["kennziffer", "bezeichnung", "preis", "konditionen_prozent", "innen_provision", "mwst_prozent", "gold_kz", "silber_kz", "platin_kz", "palladium_kz", "sonstige_kz", "barren_kz", "muenzen_kz", "zubehoer_kz", "kassetten_kz", "rchargeKz", "diffsteuerungKz", "preissteuerungKz"];

/**
 * eindeutige Identifikationsnummer des Edelmetalls
 * @member {String} kennziffer
 */
EdelmetallPreis.prototype['kennziffer'] = undefined;

/**
 * Langtext des Edelmetalls
 * @member {String} bezeichnung
 */
EdelmetallPreis.prototype['bezeichnung'] = undefined;

/**
 * Preis des Edelmetalls
 * @member {Number} preis
 */
EdelmetallPreis.prototype['preis'] = undefined;

/**
 * Prozenzsatz der Standard-Konditionen
 * @member {Number} konditionen_prozent
 */
EdelmetallPreis.prototype['konditionen_prozent'] = undefined;

/**
 * Wie hoch ist die Innenprovision
 * @member {Number} innen_provision
 */
EdelmetallPreis.prototype['innen_provision'] = undefined;

/**
 * Mehrwertsteuersatz für das Edelmetall
 * @member {Number} mwst_prozent
 */
EdelmetallPreis.prototype['mwst_prozent'] = undefined;

/**
 * @member {module:model/Boolean01} gold_kz
 */
EdelmetallPreis.prototype['gold_kz'] = undefined;

/**
 * @member {module:model/Boolean01} silber_kz
 */
EdelmetallPreis.prototype['silber_kz'] = undefined;

/**
 * @member {module:model/Boolean01} platin_kz
 */
EdelmetallPreis.prototype['platin_kz'] = undefined;

/**
 * @member {module:model/Boolean01} palladium_kz
 */
EdelmetallPreis.prototype['palladium_kz'] = undefined;

/**
 * @member {module:model/Boolean01} sonstige_kz
 */
EdelmetallPreis.prototype['sonstige_kz'] = undefined;

/**
 * @member {module:model/Boolean01} barren_kz
 */
EdelmetallPreis.prototype['barren_kz'] = undefined;

/**
 * @member {module:model/Boolean01} muenzen_kz
 */
EdelmetallPreis.prototype['muenzen_kz'] = undefined;

/**
 * @member {module:model/Boolean01} zubehoer_kz
 */
EdelmetallPreis.prototype['zubehoer_kz'] = undefined;

/**
 * @member {module:model/Boolean01} kassetten_kz
 */
EdelmetallPreis.prototype['kassetten_kz'] = undefined;

/**
 * @member {module:model/BooleanJN} rchargeKz
 */
EdelmetallPreis.prototype['rchargeKz'] = undefined;

/**
 * @member {module:model/BooleanJN} diffsteuerungKz
 */
EdelmetallPreis.prototype['diffsteuerungKz'] = undefined;

/**
 * @member {module:model/BooleanJN} preissteuerungKz
 */
EdelmetallPreis.prototype['preissteuerungKz'] = undefined;
var _default = exports.default = EdelmetallPreis;